import type { FC } from "react";
import React, { Fragment, memo } from "react";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import Insurance from "./Insurance";
import styles from "./Services.module.scss";
import useCarConfigServices from "../../../../../hooks/useCarConfigServices";
import Container from "../../../../../../shared-components/css-modules/lexus/atoms/Container";
import type { SectionWrapperPropagationProps } from "../../../common/section-wrapper/SectionWrapper";
import SectionWrapper from "../../../common/section-wrapper/SectionWrapper";
import { CarConfigConfigureSection } from "../../../../../utils/types/SectionTypes";

export type ServicesProps = SectionWrapperPropagationProps<CarConfigConfigureSection>;

const Services: FC<ServicesProps> = ({ sectionRefs }) => {
    const services = useCarConfigServices();

    if (!services?.length) return null;
    return (
        <SectionWrapper
            sectionId={CarConfigConfigureSection.Services}
            sectionRef={sectionRefs.get(CarConfigConfigureSection.Services)}
        >
            <Container>
                <div className={styles.wrapper}>
                    {services.map((service, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Fragment key={`${service.type}-${index}`}>
                            <header className={styles.header}>
                                <Text tag="h2" variant="apheleia-h2" spacing="spacing-5">
                                    {service.title}
                                </Text>
                            </header>
                            <div className={styles.content}>
                                <div
                                    style={{
                                        backgroundImage: `url(${service.bannerLinkImage as string})`,
                                        backgroundSize: "cover",
                                    }}
                                    className={styles.background}
                                >
                                    <div className={styles.overlay}>
                                        {/** TODO: later add tabs */}
                                        <Insurance />
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    ))}
                </div>
            </Container>
        </SectionWrapper>
    );
};

export default memo(Services);
